import type { IconSvgObject } from './types';

const SmartWatch01Icon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12", r: "6", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 7.5L8.85071 2.82112C8.93716 2.34563 9.35129 2 9.83458 2H14.1654C14.6487 2 15.0628 2.34563 15.1493 2.82112L16 7.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M8 16.5L8.85071 21.1789C8.93716 21.6544 9.35129 22 9.83458 22H14.1654C14.6487 22 15.0628 21.6544 15.1493 21.1789L16 16.5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }]
];

export default SmartWatch01Icon;
